<template>
    <div class="leads-colector" v-if="leadName == '' || leadEmail == ''">
            <div class="leads-colector__form">
                <h2>Fique por dentro de tudo</h2>
                <p>Saiba em primeira mão sobre o lançamento dos nossos treinos e a programação de todas as nossas lives!</p>
                <div v-if="!sended" class="leads-colector__form-wrapper">
                    <input required class="leads-colector__name-input" type="text" name="leads-colector__name" placeholder="Seu Nome"/>
                    <input required class="leads-colector__email-input" type="text" name="leads-colector__email" placeholder="Seu E-mail"/>
                    <span class="leads-colector__error-message" >Você precisa preencher corretamente os campos Nome e E-mail!</span>
                    <button class="leads-colector__send-btn" v-on:click="sendLead">Enviar</button>
                </div>
                <p v-else class="leads-colector__status-message">{{status}}</p>
            </div>
        </div>
</template>

<script>
import axios from 'axios';
import { fallback_country } from "@/fallbacks";

export default {
    data(){
        return {
            leadName: localStorage.getItem('leadName') || '',
            leadEmail: localStorage.getItem('leadEmail') || '',
            sended: false,
            loading: false,
            status: 'Sucesso! Em breve você receberá avisos sobre novas lives!'
        }
    },
    methods: {
        showEmailError(){
            document.querySelector('.leads-colector__error-message').classList.remove('show');
            setTimeout(()=> {
                document.querySelector('.leads-colector__error-message').classList.add('show');
                document.querySelector('.leads-colector__send-btn').disabled = false;
            }, 2000)
        },
        sendLead(){
            let name = document.querySelector('[name="leads-colector__name"]').value;
            let email = document.querySelector('[name="leads-colector__email"]').value;
            const nl_api = 'https://treineemcasa.bioritmo.io/index.php?rest_route=/smart/v1/newsletter';
            const re = /\S+@\S+\.\S+/;

            let insertNewsletter = () => {
                axios.post(nl_api, {
                    name,
                    email,
                    country: fallback_country
                })
                .then( () => {
                    this.loading = false
                    this.sended = true
                    localStorage.setItem('leadName', name);
                    localStorage.setItem('leadEmail', email);
                    setTimeout(() => {
                        this.dismissPopup();
                    }, 5000)
                })
                .catch( err => {
                    this.loading = false
                    this.sended = true
                    this.status = err.response.data.message;
                    setTimeout(() => {
                        this.dismissPopup();
                    }, 5000)
                })
            }

            if(!re.test(email) || name.trim() == '') {
                this.showEmailError();
            } else if(!this.loading){

                document.querySelector('.leads-colector__send-btn').disabled = true;
                this.loading = true


                //Safety Mail
                const sm_ticket_origem = '0610f4628ffb76ea66939519618b15768de39872';
                const sm_api_key = '88a9fa5c91f3394bae0a8cf7d557fb2a25f6aa44';
                const sm_main_url = 'https://optin.safetymails.com/main';
                const sm_command = 'safetyoptin';
                const sm_email_b64 = btoa(email);
                const sm_api_url = `${sm_main_url}/${sm_command}/${sm_api_key}/${sm_ticket_origem}/${sm_email_b64}`;

                axios.post(sm_api_url)
                    .then( res => {
                        if(res.data.StatusCal == 'OK'){
                            switch(res.data.StatusEmail){
                                case 'VALIDO':
                                case 'INCERTO':
                                case 'SCRAPED':
                                case 'PENDENTE':
                                    insertNewsletter();
                                break;
                                default:
                                    this.showEmailError();
                                    this.loading = false
                                break;
                            }
                        } else {
                            this.showEmailError();
                            this.loading = false
                        }
                    })


            }
        },
        dismissPopup () {
            document.querySelector('.leads-colector').classList.add('hide');
        },
    }
}
</script>

<style lang="scss" scoped>

    .leads-colector {
        font-family: "Open Sans", sans-serif;
        background: rgba(0,0,0,.8);
        position: fixed;
        z-index: 1000;
        height: 100%;
        width: 100%;
        left: 0;
        top: 0;

        &.hide {
            display: none !important;
        }

        & *:focus{
            outline: none;
        }

        &__error-message {
            font-size: 10px;
            display: none;
        }

        &__error-message.show {
            display: inherit;
        }

        &__close-btn {
            background: transparent;
            position: absolute;
            cursor: pointer;
            color: #fff;
            border: none;
            right: 0px;
            top: 0px;
            font-weight: bolder;
        }

        &__form {
            transform: translate(-50%, -50%);
            background: rgb(18,18,18);
            position: absolute;
            max-height: 400px;
            max-width: 370px;
            cursor: default;
            padding: 10px;
            left:50%;
            top:50%;

            h2 {
                color: rgb(255, 182, 18);
                font-weight: 400;
                font-size: 23px;
                text-align: center;
                line-height: 1.5;
                letter-spacing: normal;
                text-transform: uppercase;
            }

            p {
                color: rgb(255, 255, 255);
                font-weight: 400;
                font-size: 13px;
                text-align: center;
                line-height: 1.5;
                letter-spacing: normal;
            }

            input {
                color: #fff;
                background: transparent;
                border: 1px solid #888;
                width: 100%;
                margin: 10px 0px;
                border-radius: 3px;
                font-size: 14px;
                padding: 6px;
            }

        }

        &__send-btn {
            cursor: pointer;
            text-transform: uppercase;
            background: transparent;
            width: 100%;
            border: solid 1px rgb(255, 182, 18);
            border-radius: 3px;
            color: #fff;
            font-weight: bold;
            font-size: 14px;
            padding: 10px 0px;
            margin: 10px 0px;

            &:hover {
                background-color: rgba(135,135,135,0.1)
            }

            &[disabled] {
                cursor: default;
                opacity: 0.7;
            }
        }

        &__status-message {
            width: 100%;
            text-align: center;
            border-top: 1px solid #555;
            border-bottom: 1px solid #555;
            padding: 10px 0px;
            font-size: 18px !important

        }
    }

</style>